/** Topics the support chat can answer from the site's own policies. */
export type SupportTopic =
  | "hours"
  | "refund"
  | "payment"
  | "points"
  | "pricing"
  | "account"
  | "contact"
  | "human";

const TOPICS: { id: SupportTopic; keywords: string[] }[] = [
  {
    id: "human",
    keywords: [
      "human",
      "person",
      "agent",
      "someone",
      "leave a message",
      "talk to",
      "човек",
      "оператор",
      "съобщение",
      "пишете",
    ],
  },
  {
    id: "refund",
    keywords: [
      "refund",
      "money back",
      "money-back",
      "guarantee",
      "withdraw",
      "chargeback",
      "възстанов",
      "гаранция",
      "връщане",
    ],
  },
  {
    id: "hours",
    keywords: ["hour", "opening", "working time", "schedule", "работно", "часове"],
  },
  {
    id: "points",
    keywords: [
      "point",
      "credit",
      "not added",
      "didn't receive",
      "did not receive",
      "delivery",
      "missing",
      "точк",
      "доставка",
      "не са добавени",
    ],
  },
  {
    id: "payment",
    keywords: [
      "pay",
      "payment",
      "card",
      "bank",
      "subscription",
      "checkout",
      "плащан",
      "карта",
      "абонамент",
      "банка",
    ],
  },
  {
    id: "pricing",
    keywords: ["price", "pricing", "plan", "cost", "euro", "цена", "план", "струва"],
  },
  {
    id: "account",
    keywords: [
      "account",
      "sign in",
      "login",
      "log in",
      "password",
      "profile",
      "профил",
      "вход",
      "парола",
      "акаунт",
    ],
  },
  {
    id: "contact",
    keywords: ["email", "e-mail", "contact", "phone", "call", "имейл", "контакт", "телефон", "обадете"],
  },
];

/** Pick the topic that shares the most words with `text`, or null when nothing matches. */
export function matchSupportTopic(text: string): SupportTopic | null {
  const normalized = text.toLowerCase();
  let best: SupportTopic | null = null;
  let bestScore = 0;

  for (const topic of TOPICS) {
    const score = topic.keywords.reduce(
      (count, word) => count + (normalized.includes(word) ? word.length : 0),
      0
    );
    if (score > bestScore) {
      bestScore = score;
      best = topic.id;
    }
  }

  return best;
}
